import dayjs, { Dayjs } from 'dayjs';

export type TimeRange = {
  from?: string;
  to?: string;
  readonly fromFixed: string | undefined;
  readonly toFixed: string | undefined;
  readonly fromDayjs: Dayjs | undefined;
  readonly toDayjs: Dayjs | undefined;
};

export function createTimeRangeFields(json?: Partial<TimeRange>): TimeRange {
  return {
    from: json?.from || '08:00:00',
    to: json?.to || '09:00:00',

    get fromFixed(): string | undefined {
      if (this.from) {
        return this.from.length === 5 ? `${this.from}:00` : this.from.length >= 8 ? this.from.substring(0, 8) : undefined;
      }
      return undefined;
    },

    get toFixed(): string | undefined {
      if (this.to) {
        return this.to.length === 5 ? `${this.to}:00` : this.to.length >= 8 ? this.to.substring(0, 8) : undefined;
      }
      return undefined;
    },

    get fromDayjs(): Dayjs | undefined {
      return this.fromFixed ? dayjs(`2019-01-12T${this.fromFixed}`, 'YYYY-MM-DDTHH:mm:ss') : undefined;
    },

    get toDayjs(): Dayjs | undefined {
      return this.toFixed ? dayjs(`2019-01-12T${this.toFixed}`, 'YYYY-MM-DDTHH:mm:ss') : undefined;
    },
  };
}

export const createTimeRange = createTimeRangeFields;
